import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  fill: { width: '100%', flex: 1 },
});
